const GET_CEP_R = '@utils/GET_CEP_R'
const GET_CEP_S = '@utils/GET_CEP_S'
const GET_CEP_E = '@utils/GET_CEP_E'

export { GET_CEP_R, GET_CEP_S, GET_CEP_E }
